import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getValueFromId',
})
export class GetValueFromIdPipe implements PipeTransform {
  transform(array: any[], id: number): string | undefined {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return array.find((item) => item.id === id)?.value;
  }
}
